import { Outlet, ScrollRestoration } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobilePageDots from "@/components/MobilePageDots";
import WhatsAppButton from "@/components/WhatsAppButton";
import { prefetchHeroPages } from "@/lib/hero-cache";

export default function Layout() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  // Prefetch every public page's hero once, so cross-page navigation is instant.
  // Pass the current viewport bucket so the pre-warmed cache keys match what
  // HeroSlideshow will look up (which is `${page}:${device}`).
  useEffect(() => {
    const device =
      typeof window !== "undefined" && window.innerWidth < 768 ? "mobile" : "desktop";
    prefetchHeroPages(
      ["home", "home-parallax", "menus", "location", "reservation", "contact"],
      device,
    );
  }, []);

  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {!isAdmin && <WhatsAppButton />}
      {!isAdmin && <MobilePageDots />}
    </div>
  );
}
